import { IRequestContext } from '@msdyn365-commerce/core-internal';
import { useMemo } from 'react';
import { UserCentricsService } from '../UserCentricsService';

export const useUserCentricsService = (request?: IRequestContext) => {
    const userCentricsService = useMemo(() => new UserCentricsService(request), [request]);
    return userCentricsService;
};
